import Logo from '../../assests/navLogo.png'
import { Link } from 'react-router-dom';
function Footer() {
    return (
        <>
            <footer class="bg-white">
                <div class="container mx-auto px-8">
                    <div class="w-full flex flex-col md:flex-row py-6">
                        <div class="flex-1 mb-6 text-black">
                            <a class="text-pink-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl" href="/">
                                <img
                                              alt="Logo"
                                              src={Logo}
                                              className="h-8 w-auto"
                                            />
                            </a>
                        </div>
                        {/* <div class="flex-1">
                            <p class="uppercase text-gray-500 md:mb-6">Links</p>
                            <ul class="list-reset mb-6">
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <Link to="/FAQ" class="no-underline hover:underline text-gray-800 hover:text-pink-500">FAQ</Link>
                                </li>
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <Link to="/Help" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Contact Us</Link>
                                </li>
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <Link to="/Support" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Support</Link>
                                </li>
                            </ul>
                        </div> */}
                        <div class="flex-1">
                            <p class="uppercase text-gray-500 md:mb-6">Legal</p>
                            <ul class="list-reset mb-6">
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <Link to="/terms" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Terms</Link>
                                </li>
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <Link to="/privacy-policy" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Privacy</Link>
                                </li>
                            </ul>
                        </div>
                        <div class="flex-1">
                            <p class="uppercase text-gray-500 md:mb-6">Social</p>
                            <ul class="list-reset mb-6">
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <a href="https://instagram.com/nextloop.sg?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D'
           target='_blank'" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Instagram</a>
                                </li>
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <a href="https://www.facebook.com/profile.php?id=100087110787670" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Facebook</a>
                                </li>
                            </ul>
                        </div>
                        {/* <div class="flex-1">
                            <p class="uppercase text-gray-500 md:mb-6">Company</p>
                            <ul class="list-reset mb-6">
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <a href="#" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Official Blog</a>
                                </li>
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <a href="#" class="no-underline hover:underline text-gray-800 hover:text-pink-500">About Us</a>
                                </li>
                                <li class="mt-2 inline-block mr-2 md:block md:mr-0">
                                    <a href="#" class="no-underline hover:underline text-gray-800 hover:text-pink-500">Contact</a>
                                </li>
                            </ul>
                        </div> */}
                    </div>
                </div>
            </footer>
        </>)
}

export default Footer;